import { getPermissions } from "@/helper/collection";

export const ContentManagement = {
  path: "content-management",
  name: "Content Management",
  redirect: "content-management/content-management",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "list-pages",
      name: "CMS Pages",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PageComponents/listPage.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          229,
          1
        ),
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/contentmanagement.js